import * as Animate from "react-reveal";

const HireInfrastructureSection = () => {
  return (
    <section className="bg-secondary py-16 md:py-20 lg:py-24 px-4">
      <div className="container mx-auto">
        <Animate.Fade bottom>
          <p className="text-primary font-poppins text-sm font-extrabold tracking-widest uppercase mb-6">
            From talent access to workforce infrastructure
          </p>
        </Animate.Fade>

        <Animate.Fade bottom>
          <h2 className="text-3xl md:text-4xl lg:text-5xl leading-tight font-poppins font-black mb-10 lg:mb-12 max-w-3xl tracking-[-0.03em]">
            <span className="text-default">Companies Come for Talent.</span>{" "}
            <span className="text-primary block">
              They Stay for the Infrastructure.
            </span>
          </h2>
        </Animate.Fade>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10">
          <Animate.Fade bottom>
            <p className="text-[#342500] font-poppins text-lg leading-relaxed m-0">
              Finding the right person solves today&apos;s hiring problem.
            </p>
          </Animate.Fade>
          <Animate.Fade bottom>
            <p className="text-[#342500] font-poppins font-bold text-lg leading-relaxed m-0">
              Utiva solves everything that comes after—contracts, onboarding,
              compliance, payroll and workforce operations.
            </p>
          </Animate.Fade>
        </div>
      </div>
    </section>
  );
};

export default HireInfrastructureSection;
